import { ConfirmationDialog } from '@roger/ui-components';

interface TestPatientSubmitConfirmDialogProps {
  open: boolean;
  /** The real action being confirmed, e.g. "claim" or "Notice of Admission". */
  actionLabel: string;
  /** Number of test patients involved (for bulk submits); defaults to 1. */
  count?: number;
  loading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * Warns before a real payer submission (claim/NOA) for a patient marked as a
 * test/practice record. The backend refuses such a submit with a 409
 * until acknowledged; confirming here re-submits with acknowledge_test_patient
 * set, so the test flag warns rather than blocks.
 */
export function TestPatientSubmitConfirmDialog({
  open,
  actionLabel,
  count = 1,
  loading,
  onConfirm,
  onCancel,
}: TestPatientSubmitConfirmDialogProps) {
  const subject =
    count > 1
      ? `${count} of the selected records are for test patients`
      : 'This patient is marked as a test patient';
  return (
    <ConfirmationDialog
      open={open}
      title={`Send a real ${actionLabel} for a test patient?`}
      message={`${subject}. Submitting sends a real ${actionLabel} to the payer — only continue if you mean to. You will need to cancel and clean up any resulting submission manually.`}
      confirmLabel='Submit anyway'
      loading={loading}
      onAccept={onConfirm}
      onCancel={onCancel}
    />
  );
}
